import { render, staticRenderFns } from "./DialogSummaryWithFriends.vue?vue&type=template&id=fc235592&scoped=true&"
import script from "./DialogSummaryWithFriends.vue?vue&type=script&lang=ts&"
export * from "./DialogSummaryWithFriends.vue?vue&type=script&lang=ts&"
import style0 from "./DialogSummaryWithFriends.vue?vue&type=style&index=0&id=fc235592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc235592",
  null
  
)

export default component.exports